import React from 'react';
import ReportViewer from "./base/ReportViewer";

const PresencesSurTerritoire = () => {

    return (
        <div style={{height: "100%"}}>
            <ReportViewer reportName={"PresencesSurTerritoire"}/>
        </div>
    );
}
export default PresencesSurTerritoire;